import React, { useState } from 'react';
import Navigation from './Navigation';

const EditProductPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  categories, 
  selectedProduct, 
  logout, 
  updateProduct 
}) => {
  const [title, setTitle] = useState(selectedProduct?.title || '');
  const [description, setDescription] = useState(selectedProduct?.description || '');
  const [category, setCategory] = useState(selectedProduct?.category || '');
  const [price, setPrice] = useState(selectedProduct?.price || '');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    // Validation
    if (!title.trim()) {
      setError('Product title is required');
      return;
    }
    if (!description.trim()) {
      setError('Product description is required');
      return;
    }
    if (!category) {
      setError('Please select a category');
      return;
    }
    if (!price || parseFloat(price) <= 0) {
      setError('Please enter a valid price greater than 0');
      return;
    }

    // Clear error and update
    setError('');
    updateProduct(selectedProduct.id, { 
      title: title.trim(), 
      description: description.trim(), 
      category, 
      price: parseFloat(price) 
    });
    
    setCurrentPage('myListings');
  };

  if (!selectedProduct) {
    return (
      <div className="container">
        <div className="form">
          <p>No product selected for editing.</p>
          <button onClick={() => setCurrentPage('myListings')}>
            Back to My Listings
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div className="form">
        <button 
          className="back-button"
          onClick={() => setCurrentPage('myListings')}
        >
          ← Back to My Listings
        </button>
        
        <h2>Edit Product Listing</h2>
        {error && <div className="error">{error}</div>}
        
        <input
          type="text"
          placeholder="Product Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength="100"
        />
        
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
        
        <textarea
          placeholder="Product Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows="5"
          maxLength="500"
        />
        
        <input
          type="number"
          step="0.01"
          min="0.01"
          placeholder="Price in USD"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
        
        <div style={{
          padding: '30px', 
          background: '#f9f9f9', 
          textAlign: 'center', 
          margin: '15px 0',
          border: '2px dashed #ccc',
          borderRadius: '8px'
        }}>
          <div style={{fontSize: '24px', marginBottom: '10px'}}>📷</div>
          <p>Current Image (Placeholder)</p>
          <p style={{fontSize: '12px', color: '#666'}}>Click to change image</p>
        </div>
        
        <button onClick={handleSubmit}>
          Update Listing
        </button>
        
        <button onClick={() => setCurrentPage('myListings')} style={{background: '#666'}}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditProductPage;